export default "__VITE_ASSET__CB45wg6X__"